export const Validators = {
  isRequired: "required",
  isEmail: "isEmail",
  isValidEmail: "isValidEmail",
  minStringLength(length) {
    return `minStringLength:${length}`;
  },
  isUserExists: "isUserExists",
  isValidURL: "isValidURL"
};

export const ErrorMessage = {
  isRequired: "This field is required",
  isEmail: "Incorrect email format",
  minStringLength(length) {
    return `This field should contains at least ${length} chararcters`
  },
  isUserExists: "User not found",
  isValidURL: "Invalid URL"
};

// working
export const googleAPIKey = "AIzaSyDfNulEDBuLL-IJAsEfsFOZtkNQmmIW1-Q"

// export const googleAPIKey = "AIzaSyCBSyE11KyK_u-83czIq5OtGySjzv0Iudg"
// export const googleAPIKey = "AIzaSyCBSyE11KyK_u-83czIq5OtGySjzv0Iudg"
// export const googleAPIKey = "AIzaSyBF-1xkURirRLRnx3exGzbJBGk9TvPIi9c"

export const adminObjectId = "9hfx3HPJEy";